import { RootState } from "../../../rootReducer";

export const selectIsLoading = (state: RootState) => state.updateVenues.loading;
export const selectErrorMessage = (state: RootState) =>
  state.updateVenues.error;
export const updateVenuesResponse = (state: RootState) =>
  state.updateVenues.updateVenuesResponse;
